import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import {
    Container,
    Spinner
} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';
import VendorsFormContentView from './Includes/VendorsFormContentView'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ERROR_WHILE_CREATING_VENDOR,
    VENDOR_ADDED_SUCCESSFULLY
} from 'utlis/AppMessages/AppMessages'
import { formValidationSchema, initialCreateFormValues } from './Helper'
import { addVendor } from 'utlis/Apis/Vendor_API'
import { useFormik } from 'formik';
import { getCustomerCountries } from 'utlis/Apis/Customers_API';

function CreateVendor(props) {
    const submitButtonRef = useRef(null)

    const [createButtonDisable, setCreateButtonDisable] = useState(false)
    const [createButtonLoading, setCreateButtonLoading] = useState(false)
    const [countries, setCountries] = useState([])
    useEffect(() => {
        getCountries_()
    }, [])
    const getCountries_ = () => {
        getCustomerCountries().then(res => {
            const countriesData = res.data
            if (countriesData.success) {
                setCountries(countriesData.data)
            }
            if (countriesData.error) {
                console.log('Error occured while loading countries groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }
    const onCreateFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setCreateButtonDisable(true)
            setCreateButtonLoading(true)
            addVendor(props.currentUser.userToken, values).then(res => {
                setGlobalLoading(false)

                const addingVendor = res.data
                if (addingVendor.success) {
                    setCreateButtonLoading(false)
                    window.scrollTo(0, 0)
                    props.history.push('/catalog/vendors', {
                        shouldReload: true
                    })
                    formik.resetForm()
                    toast.dismiss();
                    toast.success(VENDOR_ADDED_SUCCESSFULLY, {
                        autoClose: 2000,
                        onClose: () => {

                        }
                    })
                }
                if (addingVendor.error) {
                    console.log(ERROR_WHILE_CREATING_VENDOR, res)
                    setCreateButtonDisable(false)
                    setCreateButtonLoading(false)
                    toast.dismiss();
                    toast.error(ERROR_WHILE_CREATING_VENDOR, {
                        autoClose: 3000,
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} vendors `, err.message)
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        setGlobalLoading(false)
                        setCreateButtonDisable(false)
                        setCreateButtonLoading(false)
                    }
                })
            })
        }
    }
    // formik hook
    const formik = useFormik({
        initialValues: initialCreateFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onCreateFormSubmit,
        enableReinitialize: true
    })

    // handle button submission
    const handleFormSubmission = (ev) => {
        ev.preventDefault()

        // triggering click on submit button
        submitButtonRef.current.click()
    }

    return (
        <section id="app-vendors__create-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-vendors__create-details">
                    {/* HEADING WRAPPER */}
                    <div className="app-header-wrapper mb-3">
                        {/* heading */}
                        <p className="app-heading text-capitalize">Create Vendors</p>
                        <p className="app-desc">
                            Create a vendor.
                        </p>
                    </div>

                    {/* CONTENT WRAPPER */}
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            <VendorsFormContentView
                                formik={formik}
                                countries={countries}
                            />

                            {/* app card : bottom-bar */}
                            <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to="/catalog/vendors" className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={createButtonDisable}
                                        onClick={handleFormSubmission}>
                                        {
                                            createButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Create Vendor</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(CreateVendor)